import React, { createContext, useContext, useState } from 'react'

export const CrmInfoContext = createContext([])
export const useCrmInfo = () => useContext(CrmInfoContext)

export interface IState {
  id: string
  name: string
}

type ContainerProps = {
  children: React.ReactNode
}

export const CrmInfoState: React.FC<ContainerProps> = ({ children }) => {
  const [crmInfo, setCrmInfo] = useState<IState | null>(null)

  return <CrmInfoContext.Provider value={[crmInfo, setCrmInfo]}>{children}</CrmInfoContext.Provider>
}
